module.exports = __webpack_public_path__ + "static/media/1.d9848ba8.jpg";